import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const editVehicle = async (data) => {
  try {
    return await postRequest(urls.EDIT_VEHICLE, data);
  } catch (err) {
    return err;
  }
};
